// extracted by mini-css-extract-plugin
export var contentContainer = "ContentMediaSection-module--contentContainer--ddda7";
export var description = "ContentMediaSection-module--description--486ea";
export var mediaContainer = "ContentMediaSection-module--mediaContainer--2465e";
export var mediaImage = "ContentMediaSection-module--mediaImage--a6827";
export var mothersdayDescription = "ContentMediaSection-module--mothersdayDescription--74209";